import React from 'react';
import { InputBase, NativeSelect } from '@material-ui/core';
import { uniqBy } from 'lodash';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { ReactComponent as ChevronDown } from 'images/at_chevron-down.svg';

import styles from './dropdown.module.css';

// Migrated off react-bootstrap (Form.Control as="select") to MUI NativeSelect.
// InputBase (unstyled) is used so the bordered-box look is fully controlled by
// dropdown.module.css. Native <option> rendering + the placeholder/uniqBy
// behaviour are preserved.
const Dropdown = ({ items, placeholder, isInvalid, disabled, ...props }) => {
    const options = items && placeholder ? [{ label: placeholder, value: '' }, ...items] : items;

    return (
        <NativeSelect
            {...props}
            disabled={disabled}
            input={<InputBase />}
            IconComponent={ChevronDown}
            className={cn(styles.formControl, {
                [styles.error]: isInvalid,
                [styles.disable]: disabled,
            })}
            classes={{ select: styles.select, icon: styles.icon }}
        >
            {uniqBy(options, 'value').map((item, i) => (
                <option key={item.value + i} value={item.value}>
                    {item.label}
                </option>
            ))}
        </NativeSelect>
    );
};

Dropdown.propTypes = {
    placeholder: PropTypes.string,
    items: PropTypes.array,
    isInvalid: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default Dropdown;
